import { IconTable } from "@tabler/icons-react";
import { GRAY_PALETTE } from "~/styles/palettes";
import { Button, Flex, Paper, ThemeIcon } from "~/ui";
import type { ReportArtifactSummary } from "./report-artifact-state";

import { formatCalendarDay } from "./report-field-formatters";
import { TruncatingTitle } from "./TruncatingTitle";

interface AssistantArtifactCardProps {
  summary: ReportArtifactSummary;
  hasDataset: boolean;
  onOpen: () => void;
}
export const AssistantArtifactCard = ({ summary, hasDataset, onOpen }: AssistantArtifactCardProps) => (
  <Paper p="sm" radius="md" w="100%" style={{ border: `1px solid ${GRAY_PALETTE[3]}` }}>
    <Flex align="center" justify="space-between" gap="sm">
      <Flex align="center" gap="sm" style={{ flex: "1 1 0" }}>
        <ThemeIcon size={30} variant="light" color="blue" radius="md" style={{ flexShrink: 0 }}>
          <IconTable size={16} />
        </ThemeIcon>
        <TruncatingTitle
          title={summary.title}
          secondary={`${summary.coverage}${summary.asOf ? ` · As of ${formatCalendarDay(summary.asOf) || summary.asOf}` : ""}`}
        />
      </Flex>
      <Button size="xs" variant="light" onClick={onOpen} style={{ flexShrink: 0 }}>
        {hasDataset ? "Open report" : "Open latest report"}
      </Button>
    </Flex>
  </Paper>
);
